import { getFeatureEnabled, ipCountryQuery, configQuery, isMobileQuery } from '@gig/magic-common';
import { BREAKPOINT_DEVICE_UPDATED, USER_LOGGED_IN_UPDATED, GAMEPLAY_BLOCK_LAUNCH_QUERY, GAMEPLAY_SIDENAV_QUERY, GAMEPLAY_SIDENAV_UPDATED, GAMEPLAY_BLOCK_LAUNCH_UPDATED, Feature } from '@gig/magic-messages';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class GameplayService {
  constructor() {
    this.isMobile = false;
    this.loggedIn = false;
    this.registerSchemas();
    this.subscribeToSideNavChanges();
    this.subscribeToBlockLaunchChanges();
  }
  subscribeToSideNavChanges() {
    window.eventBus.subscribe([BREAKPOINT_DEVICE_UPDATED, USER_LOGGED_IN_UPDATED], (event) => __async(this, null, function* () {
      var _a, _b;
      this.isMobile = yield isMobileQuery();
      this.loggedIn = (_b = (_a = event.payload) == null ? void 0 : _a[1]) != null ? _b : false;
      yield this.updateSideNav();
    }), { replay: true });
  }
  subscribeToBlockLaunchChanges() {
    window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (event) => __async(this, null, function* () {
      var _a;
      this.loggedIn = (_a = event.payload) != null ? _a : false;
      yield this.updateBlockLaunch();
    }), { replay: true });
    window.queryBus.subscribe(GAMEPLAY_BLOCK_LAUNCH_QUERY, () => __async(this, null, function* () {
      return yield this.shouldBlockLaunch();
    }));
    window.queryBus.subscribe(GAMEPLAY_SIDENAV_QUERY, () => __async(this, null, function* () {
      return yield this.shouldEnableSideNav();
    }));
  }
  updateSideNav() {
    return __async(this, null, function* () {
      const enabled = yield this.shouldEnableSideNav();
      window.eventBus.publish(GAMEPLAY_SIDENAV_UPDATED, enabled);
    });
  }
  updateBlockLaunch() {
    return __async(this, null, function* () {
      const shouldBlock = yield this.shouldBlockLaunch();
      window.eventBus.publish(GAMEPLAY_BLOCK_LAUNCH_UPDATED, shouldBlock);
    });
  }
  shouldEnableSideNav() {
    return __async(this, null, function* () {
      const quickDepositEnabled = yield getFeatureEnabled(Feature.QUICK_DEPOSIT);
      return quickDepositEnabled && this.isMobile && this.loggedIn;
    });
  }
  shouldBlockLaunch() {
    return __async(this, null, function* () {
      if (this.loggedIn) {
        return false;
      }
      const [countries, ipCountry] = yield Promise.all([
        this.getBlockedLaunchCountries(),
        ipCountryQuery()
      ]);
      return countries.includes(ipCountry);
    });
  }
  getBlockedLaunchCountries() {
    return __async(this, null, function* () {
      var _a;
      return (_a = yield configQuery("gamePlay.playForFunBlockedCountriesWithInfo")) != null ? _a : [];
    });
  }
  registerSchemas() {
    window.eventBus.register(GAMEPLAY_SIDENAV_UPDATED, {
      type: "boolean"
    });
    window.eventBus.register(GAMEPLAY_BLOCK_LAUNCH_UPDATED, {
      type: "boolean"
    });
  }
}

export { GameplayService };
